import { MissingStatement } from '@/features/user/your-practice/documents/lib/userDocuments.slice'
import { isoToUTCDateTime, DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { TypographyStyles } from '@/styles'
import { Accordion, List, Text } from '@/ui'

interface MissingStatementsProps {
  neededStatements?: MissingStatement[]
  title: string
}

export const MissingStatementsAccordion = ({
  neededStatements,
  title,
}: MissingStatementsProps) => {
  if (!neededStatements || neededStatements.length === 0) {
    return null
  }

  return (
    <Accordion variant="text" type="single" collapsible>
      <Accordion.Item value="item-1">
        <Accordion.Trigger className="text-brand no-underline">
          {title}
        </Accordion.Trigger>

        <Accordion.Content>
          {neededStatements.map(
            ({ financial_institution_name, name, mask, statements }) => {
              const accountText = `${financial_institution_name} ${name}: ${mask}`

              return (
                <div key={accountText}>
                  <Text variant={TypographyStyles.H3}>{accountText}</Text>

                  <List>
                    {statements.map((statement) => (
                      <List.Item key={`${accountText} ${statement}`}>
                        <Text className="text-orange-100">
                          {isoToUTCDateTime(statement).toFormat(
                            DATE_FORMATS_LUXON.MONTH_YEAR_LONG
                          )}
                        </Text>
                      </List.Item>
                    ))}
                  </List>
                </div>
              )
            }
          )}
        </Accordion.Content>
      </Accordion.Item>
    </Accordion>
  )
}
